import {
  PlaneBufferGeometry,
  MeshNormalMaterial,
  Mesh,
  TextureLoader,
  RepeatWrapping,
  Object3D
} from 'three'
// import { Water as BaseWater } from 'three/examples/jsm/objects/Water'
// import { Water as BaseWater } from 'three/examples/jsm/objects/Water2'

import { BaseWater } from './BaseWater'

import { Component } from 'shimmer'

// NEED TO REMOVE GROUND TO ADD THIS ONE


export class Water extends Component {
  constructor (obj) {
    super()

    this.loadTextures().then(() => {
      // this.water = new Mesh(obj.geometry.clone(), new MeshNormalMaterial())

      // this.water = new BaseWater(obj.geometry.clone(), {
      this.water = new BaseWater(obj.geometry.clone(), {
        textureWidth: 1024,
        textureHeight: 1024,
        normalMap0: this.normal1,
        normalMap1: this.normal2,
        reflectivity: 1,
        flowSpeed: .01,
        color: 0x222222,
        scale: 5
      })

      this.resolve()
      this.add(this.water)
    })

    this.renderOrder = -10000
    // this.rotation.x = Math.PI

  }

  update ({delta}) {
    if (this.water) {
      this.water.updateFlow(delta)
    }
  }

  loadTextures () {
    this.normal1 = null
    this.normal2 = null

    return Promise.all([
      new Promise((resolve, reject) => {
        // new TextureLoader().load('/images/textures/water_1_m_normal.jpg', (texture) => {
        new TextureLoader().load('/images/textures/water_1_m_normal--3--2.jpg', (texture) => {
          texture.wrapS = texture.wrapT = RepeatWrapping
          this.normal1 = texture
          resolve()
        })
      }),
      new Promise((resolve, reject) => {
        // new TextureLoader().load('/images/textures/water_2_m_normal.jpg', (texture) => {
        new TextureLoader().load('/images/textures/water_1_m_normal--2--2.jpg', (texture) => {
          texture.wrapS = texture.wrapT = RepeatWrapping
          this.normal2 = texture
          resolve()
        })
      })
    ])
  }
}